/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-13 06:11:25
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, TextStyle, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getShop } from 'src/helpers';
import { URL } from 'src/constants/links';
import { showChatbox } from 'src/integrations/chatbox';
import { isFreemiumPlan } from 'src/helpers/subscription-v4-helper';

type Props = {
  sendRequest: Function
};

type ComposedProps = Props & WithI18nProps;

type State = {
  activeInfoBanner: boolean
};
class InfoBanner extends Component<ComposedProps, State> {
  state = {
    // Show info banner
    activeInfoBanner: true
  };

  componentDidMount() {
    // Display info banner
    this.showInfoBanner();
  }

  openChatBox = () => {
    showChatbox();
  };

  render() {
    const { i18n, tenantApp } = this.props;
    const isFreemium = isFreemiumPlan(tenantApp);

    if (this.state.activeInfoBanner) {
      return (
        <div className="infoBanner">
          <Banner
            title={i18n.translate('AdminHTML.FilterTree.Item.infoBanner_BannerTitle')}
            onDismiss={this.handleDismissInfoBanner}
            status="info">
            <p>
              {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Paragraph1_Content', {
                t: (
                  <Link external url={URL['CustomFilterOptionByTag']}>
                    {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Paragraph1_Content_t')}
                  </Link>
                )
              })}
            </p>
            <p>
              {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Paragraph2_Content', {
                t: (
                  <Link external url={URL['DisplaySwatchInFilter']}>
                    {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Paragraph2_Content_t')}
                  </Link>
                )
              })}
            </p>
            <p>
              {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Paragraph3_Content', {
                t: (
                  <Link external url={URL['ManualSortFilterOption']}>
                    {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Paragraph3_Content_t')}
                  </Link>
                )
              })}
            </p>
            {!isFreemium && (
              <p>
                <TextStyle variation="strong">
                  {i18n.translate('AdminHTML.Common.Title.important')}
                </TextStyle>{' '}
                {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Content3', {
                  t1: (
                    <span
                      style={{ textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={showChatbox}>
                      {i18n.translate('AdminHTML.FilterTree.Item.infoBanner_Content3_t1')}
                    </span>
                  )
                })}
              </p>
            )}
          </Banner>
        </div>
      );
    }
    return '';
  }

  // Show info banner
  showInfoBanner = () => {
    let dismiss = false;
    try {
      dismiss = localStorage.getItem(`${getShop()}-dismissFilterTreeItemBanner`);
    } catch (error) {}

    // If the banner is dismissed, hide it
    if (dismiss) {
      this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
    }
  };

  // Handle dismiss info banner
  handleDismissInfoBanner = () => {
    try {
      localStorage.setItem(`${getShop()}-dismissFilterTreeItemBanner`, 'true');
    } catch (error) {}
    this.setState(({ activeInfoBanner }) => ({ activeInfoBanner: !activeInfoBanner }));
  };
}

export default withI18n()(InfoBanner);
